export const GET_ALL_STATE = "/get/courses/name";
export const Subject_Name = "/get/subjectlevel/name"
export const University_name="/get/university/name"
export const Country_name="/get/country/name"
export const Search_course="/get/courses"
export const FAQ_data="/get/faq"
export const Videosdata="/get/videos"
export const Countrydream="/get/countries"
export const TestiMonials = "/storyboard?page=1&size=10"
export const getAllBlogs = "/blogs"
export const getAllGallery = "/gallery"